export const ASSET_TYPE_LIST = "ASSET_TYPE_LIST";
export const ASSET_TYPE_LIST_SUCCESS = "ASSET_TYPE_LIST_SUCCESS";
export const ASSET_TYPE_LIST_FAILURE = "ASSET_TYPE_LIST_FAILURE";

export const ASSET_TYPE_DATA = "ASSET_TYPE_DATA";
export const ASSET_TYPE_DATA_SUCCESS = "ASSET_TYPE_DATA_SUCCESS";
export const ASSET_TYPE_DATA_FAILURE = "ASSET_TYPE_DATA_FAILURE";

export const ASSET_TYPE_CREATE = "ASSET_TYPE_CREATE";
export const ASSET_TYPE_CREATE_SUCCESS = "ASSET_TYPE_CREATE_SUCCESS";
export const ASSET_TYPE_CREATE_FAILURE = "ASSET_TYPE_CREATE_FAILURE";

export const ASSET_TYPE_UPDATE = "ASSET_TYPE_UPDATE";
export const ASSET_TYPE_UPDATE_SUCCESS = "ASSET_TYPE_UPDATE_SUCCESS";
export const ASSET_TYPE_UPDATE_FAILURE = "ASSET_TYPE_UPDATE_FAILURE";

export const ASSET_TYPE_DELETE = "ASSET_TYPE_DELETE";
export const ASSET_TYPE_DELETE_SUCCESS = "ASSET_TYPE_DELETE_SUCCESS";
export const ASSET_TYPE_DELETE_FAILURE = "ASSET_TYPE_DELETE_FAILURE";
